/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_New_Source_AddInputs */

const vi_sl_new_source_add = /** @type {(inputs: Sl_New_Source_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm lô nguồn`)
};

/**

* @param {Sl_New_Source_AddInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_new_source_add = /** @type {((inputs?: Sl_New_Source_AddInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_New_Source_AddInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_new_source_add(inputs)
});